import axios from 'axios';
import { addFormSubmissionFailed } from '../../FormPropertyAction/FormPropertyAction';
import { convertQuestionsToArray } from '../../../../components/CASAForm/Utilities';
import { renderToString } from 'react-dom/server'

export const ADDITIONAL_PAYMENT_SUBMISSION_BEGIN = 'ADDITIONAL_PAYMENT_SUBMISSION_BEGIN';
export const ADDITIONAL_PAYMENT_SUBMISSION_SUCCESS = 'ADDITIONAL_PAYMENT_SUBMISSION_SUCCESS';
export const ADDITIONAL_PAYMENT_SUBMISSION_FAILURE = 'ADDITIONAL_PAYMENT_SUBMISSION_FAILURE';

export const additionalPaymentSubmissionBegin = () => ({
    type: ADDITIONAL_PAYMENT_SUBMISSION_BEGIN
});

export const additionalPaymentSubmissionSuccess = (response) => ({
    type: ADDITIONAL_PAYMENT_SUBMISSION_SUCCESS,
    payload: response
});

export const additionalPaymentSubmissionFailure = (errors) => ({
    type: ADDITIONAL_PAYMENT_SUBMISSION_FAILURE,
    payload: errors
});

export const additionalPaymentSubmission = (webappurlForms, accessToken, formProperties, formData, submissionId, declarationText) => {
  return dispatch => {
    const options = {
      headers: {
        'Authorization': "Bearer " + accessToken,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    };

    const data = {
      "orgid": formProperties.orgid,
      "organisationArn": formProperties.organisationArn,
      "rootFormCode": formProperties.rootFormCode,
      "formCode": formProperties.formCode,
      "formData": {
        "steps": convertQuestionsToArray(formData.steps),
        "calcs": Object.values(formData.calcs),
        "submissionId": submissionId,
        "declarationText": renderToString(declarationText)
      },
      "name": formProperties.name,
      "version": formProperties.version
    }

    dispatch(additionalPaymentSubmissionBegin());
      return axios.post(webappurlForms + `/api/myCASA/Forms/Submissions/${submissionId}/Payment/v1`, { "data": btoa(escape(JSON.stringify(data))) }, options)
      .then(response => {
        if (response.data.wasSuccessful && response.data.securePaymentToken) {
          return dispatch(additionalPaymentSubmissionSuccess({ securePaymentToken: response.data.securePaymentToken }));
        }
        else {
          dispatch(addFormSubmissionFailed())
          return dispatch(additionalPaymentSubmissionFailure(response.data.errors));
        }
      })
      .catch(error => {
        dispatch(addFormSubmissionFailed())
        return dispatch(additionalPaymentSubmissionFailure(error.response?.data.errors ?? error.message));
      });
  };
}
